export interface Testimonial {
  id: string;
  userName: string;
  avatarUrl: string;
  rating: number;
  content: string;
  date: string;
}

export const testimonials: Testimonial[] = [
  {
    id: 't-1',
    userName: '小雨点',
    avatarUrl: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20woman%20portrait%2C%20warm%20smile%2C%20natural%20makeup%2C%20soft%20studio%20lighting%2C%20simple%20light%20background%2C%20friendly%20expression%2C%20clean%20professional%20headshot&width=120&height=120&seq=avatar-01&orientation=squarish',
    rating: 5,
    content: '每天下班回家就打开羞羞视频看看，一天的疲惫都没了！内容真的太有趣了，特别是萌宠分类，我家猫都跟着一起看～',
    date: '2026-08-10',
  },
  {
    id: 't-2',
    userName: '大熊爱生活',
    avatarUrl: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20man%20portrait%2C%20friendly%20smile%2C%20casual%20style%2C%20soft%20studio%20lighting%2C%20simple%20light%20background%2C%20clean%20professional%20headshot%2C%20warm%20expression&width=120&height=120&seq=avatar-02&orientation=squarish',
    rating: 5,
    content: '女朋友推荐给我的，一开始还觉得不好意思，结果一看就停不下来了！恋爱日常分类里的视频简直是我们的翻版，太真实了哈哈哈！',
    date: '2026-08-09',
  },
  {
    id: 't-3',
    userName: '喵星人铲屎官',
    avatarUrl: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20woman%20with%20glasses%20portrait%2C%20gentle%20smile%2C%20warm%20expression%2C%20soft%20studio%20lighting%2C%20simple%20light%20background%2C%20clean%20professional%20headshot&width=120&height=120&seq=avatar-03&orientation=squarish',
    rating: 5,
    content: '作为一个资深猫奴，搞怪萌宠分类简直就是我的快乐源泉！每天都要刷好几遍，视频质量很高，推荐给了好多朋友！',
    date: '2026-08-08',
  },
  {
    id: 't-4',
    userName: '远方的情书',
    avatarUrl: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20woman%20with%20long%20hair%20portrait%2C%20sweet%20smile%2C%20soft%20studio%20lighting%2C%20simple%20light%20background%2C%20clean%20professional%20headshot%2C%20warm%20natural%20expression&width=120&height=120&seq=avatar-04&orientation=squarish',
    rating: 5,
    content: '异地恋中，每次看到甜蜜互动的视频都会分享给男朋友。这些视频让我觉得爱情真的很美好，也给了我们坚持下去的勇气！',
    date: '2026-08-07',
  },
  {
    id: 't-5',
    userName: '快乐的小明',
    avatarUrl: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20man%20with%20casual%20style%20portrait%2C%20bright%20smile%2C%20soft%20studio%20lighting%2C%20simple%20light%20background%2C%20clean%20professional%20headshot%2C%20friendly%20expression&width=120&height=120&seq=avatar-05&orientation=squarish',
    rating: 4,
    content: '趣味搞笑分类的视频真的太好笑了！每次和室友一起看都笑得前仰后合。希望更新再快一点，不够看啊！',
    date: '2026-08-06',
  },
  {
    id: 't-6',
    userName: '暖暖的小太阳',
    avatarUrl: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20woman%20with%20warm%20smile%20portrait%2C%20bright%20eyes%2C%20soft%20studio%20lighting%2C%20simple%20light%20background%2C%20clean%20professional%20headshot%2C%20cheerful%20expression&width=120&height=120&seq=avatar-06&orientation=squarish',
    rating: 5,
    content: '情感故事分类里的视频每次看都很感动，外卖小哥那期我看了三遍哭了三遍。谢谢你把这些温暖的故事收集起来～',
    date: '2026-08-05',
  },
];